// var backend_base_url = 'https://forms01.soflomo.com/';
var backend_base_url = 'https://challenge.hilversum100.nl';

module.exports = {
    siteUrl: 'https://www.hilversum100.nl',
    facebookId: '',
    analyticsId: '',
    contentfulSpace: 'n8t2672973fy',
    contentfulHost: 'cdn.contentful.com',
    contentfulAccessToken: '96ddfd77f36d1a6e0d1a623c6494275f522e9a8f791191fef9da2ab11f39aeaf',
    // Preview settings
    //contentfulHost: 'preview.contentful.com',
    //"contentfulAccessToken": "e784b84c3bfb1a86a6b6365c909525dcdcaa9324643c15185633d9489f2761aa"
    mailSenderEndpoint : backend_base_url + "/mail",
	restEndpoint: backend_base_url + "/data",
    voteEndpoint: backend_base_url + "/request-vote/",
    challengeOpen: "2019-07-01T00:00:00",
    challengeClosed: "2019-09-29T00:00:00",
    votingOpen: "2019-10-01T00:00:00",
    votingClosed: "2019-10-07T12:00:00",
    fineUploaderTraditionalOptions: {
        debug: true,
        request: {
            endpoint: backend_base_url + '/uploads' // for localhost, components/ChallengeForm/index.jsx::getValidationSchema planPublicUrl -> url -> allowLocal: true
        },
        retry: {
            enableAuto: true // defaults to false
        }
    },
    fineUploaderOptions: {
        request: {
            endpoint: "https://hilversumh100.s3.eu-central-1.amazonaws.com",
            // accessKey: "AKIAIGWPSEOAB33XF7BA",
            accessKey: "AKIAJO7MTCOOPGUQA6FA",
        },
        signature: {
            // endpoint: "https://shop.soflomo.com:8888/s3/sign",
            endpoint: backend_base_url + "/s3/sign",
            version: 4,
        },
        objectProperties: {
            region: "eu-central-1",
            bucket: "hilversumh100",
            acl: "public-read",
        },
        validation: {
            sizeLimit: 524288000, // used for policy only
        },
        retry: {
            enableAuto: true // defaults to false
        },
        multiple: false
    }
};
